const uiConfig = {
  inputFontSize: "14px",
};

export default uiConfig;
